// extracted by mini-css-extract-plugin
export default {"button":"ConstructorTextButton_button__byJBr","active":"ConstructorTextButton_active__tLZuL","inactive":"ConstructorTextButton_inactive__7b5bP"};